export const saveData = (name, data) => {
    localStorage.setItem(name, JSON.stringify(data));
};
